export { default as DetailView } from './DetailView';
export { default as OverviewView } from './OverviewView';
export { default as VivView } from './VivView';
export { default as SideBySideView } from './SideBySideView';
